import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Flatten } from 'shared/helpers';
import { renderables } from 'shared/constants';

import Styles from './ComparativoNutricional.module.scss';
import { faCode } from '@fortawesome/free-solid-svg-icons';

import { Creators as reduxProdutos } from 'store/ducks/produtos';
import { Creators as reduxEtapas } from 'store/ducks/etapas';

import Header from 'components/Header/Header';
import Table from './Table/Table';
import Subtable from 'components/Subtable/Subtable';
import PrintButton from 'components/PrintButton/PrintButton';

export default function ComparativoNutricional({ match }) {
  const { ComparativoNutricional, Main, PullLeft } = Styles;
  const { id } = match.params;

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(reduxEtapas.getEtapas(id));
    dispatch(reduxProdutos.getProdutos());
  }, [id, dispatch]);

  const RProdutos = useSelector((state) => state.produtos.data);
  const Etapas = useSelector((state) => state.etapas.data);
  const pem = useSelector((state) => state.etapas.pem);

  const Produtos = RProdutos.map((x) => ({
    N: Number(x.NH2) + Number(x.NH4) + Number(x.NO3),
    ...x,
  }));

  const RelevantProdutos = Flatten(
    Etapas.map((etapa) =>
      etapa.produtos.map((produto) => ({
        ...Produtos.find((x) => x.id === produto.id),
        ...produto,
      })),
    ),
  );

  const tableRef = useRef();

  return pem !== id ? null : (
    <div className={ComparativoNutricional}>
      <Header icon={faCode} title={'COMPARAÇÃO PROGRAMAS NUTRICIONAIS'}>
        <PrintButton fitElements={[tableRef]} />
      </Header>
      <div className={Main}>
        <Table
          tableRef={tableRef}
          renderables={renderables}
          etapas={Etapas}
          produtos={Produtos}
          tableKey={'ComparativoNutricional'}
        />
        <div className={PullLeft}>
          <p>* micro elementos que podem ser quelatados</p>
          <Subtable produtos={RelevantProdutos} />
        </div>
      </div>
    </div>
  );
}

ComparativoNutricional.propTypes = {
  match: PropTypes.any.isRequired,
};
